import { useMatches } from 'react-router-dom';
import type { PageId } from '@nexa/content';

interface PageHandle {
  readonly pageId: PageId;
}

function hasPageId(handle: unknown): handle is PageHandle {
  return typeof handle === 'object' && handle !== null && 'pageId' in handle;
}

/**
 * Lấy id trang hiện tại từ `handle` của route, thay vì so khớp `location.pathname` bằng chuỗi.
 *
 * Khác biệt quan trọng: slug đổi theo ngôn ngữ (`/vi/tinh-nang` vs `/en/features`), nên so khớp
 * đường dẫn sẽ phải viết bảng ngược slug → trang và bảng đó sẽ lệch. `handle` do router gắn nên
 * luôn khớp với route đang render.
 */
export function usePageId(): PageId | undefined {
  const matches = useMatches();
  for (let index = matches.length - 1; index >= 0; index -= 1) {
    const handle = matches[index]?.handle;
    if (hasPageId(handle)) return handle.pageId;
  }
  return undefined;
}
